exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".input-form-text-box[data-v-17b445a8] {\n  text-align: left;\n}\n.input-form-text-box__label[data-v-17b445a8] {\n    margin-bottom: 8px;\n}\n", ""]);
